import { render } from "./WebcamFeed.vue?vue&type=template&id=b3f7aa06"
import script from "./WebcamFeed.vue?vue&type=script&lang=js"
export * from "./WebcamFeed.vue?vue&type=script&lang=js"

import "./WebcamFeed.vue?vue&type=style&index=0&id=b3f7aa06&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__